import { alpha, Components, Theme } from '@mui/material'
import { getAssetUrl } from '../../utils/assetUrl'
import { basicTheme, buttonSize } from '../theme-v2'

const bubbles = getAssetUrl('/animations/rewards/bubbles.svg')

export const MuiLinearProgress: Components<Theme>['MuiLinearProgress'] = {
    defaultProps: {
        size: 'small',
        variant: 'determinate',
    },
    variants: [
        {
            props: { animated: true },
            style: (props: any) => ({
                position: 'relative',
                overflow: 'hidden',
                '@keyframes bubbleScroll': {
                    from: {
                        backgroundPosition: '0px center',
                    },
                    to: {
                        backgroundPosition: '544px center',
                    },
                },
                '::after': {
                    content: '""',
                    display: props['aria-valuenow'] ? 'block' : 'none',
                    position: 'absolute',
                    borderRadius: '4px',
                    width: 'calc(100% - 4px)',
                    height: '100%',
                    top: 0,
                    left: 0,
                    right: 0,

                    transform: `translateX(${-100 + props['aria-valuenow']}%)`,
                    transition: 'transform .4s linear',

                    backgroundImage: `url(${bubbles})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'repeat-x',
                    animation: 'bubbleScroll 24s linear infinite',
                },
            }),
        },
        {
            props: { meter: true },
            style: (props: any) => {
                const height = buttonSize[props.ownerState.size].replace('px', '')
                const ratio = 1.5
                const sections = 3
                const outline = 2
                const size = height / ratio / sections - outline * 2

                return {
                    // compensate for outline
                    height: `calc(${height}px / ${ratio} - ${outline * 2}px)`,
                    outline: `${outline}px solid #777`,
                    backgroundColor: '#393939',
                    border: '2px solid',
                    borderColor: basicTheme.palette.background.default,
                    margin: '2px',
                    borderRadius: '6px',
                    '& .MuiLinearProgress-bar': {
                        borderRadius: '4px',
                        overflow: 'hidden',
                        '::before': {
                            content: '""',
                            position: 'absolute',
                            borderRadius: '2px 2px 0px 0px',
                            width: `calc(${props['aria-valuenow']}% - ${outline / 2}px)`,
                            right: `${outline}px`,
                            top: `${outline}px`,
                            height: size,
                            backgroundColor: alpha(basicTheme.palette.common.white, 0.8),
                            transition: 'width .4s linear',
                        },
                        '::after': {
                            content: '""',
                            position: 'absolute',
                            borderRadius: '0px 0px 2px 2px',
                            width: `calc(${props['aria-valuenow']}% - ${outline}px)`,
                            transition: 'width .4s linear',
                            right: `${outline}px`,
                            bottom: `${outline}px`,
                            height: size,
                            backgroundColor: basicTheme.palette[props.ownerState.color].dark,
                        },
                    },
                }
            },
        },
    ],
}
